import { useNavigate } from "react-router-dom";
import Error from "../assets/Login/Error.jpg";

function ErrorPage() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  return (
    <div className="h-screen w-full min-w-[340px]">
      <main className="font-inter flex flex-col lg:flex-row items-center justify-center h-screen w-full">
        <img src={Error} alt="" className="w-[600px] h-auto"></img>
        <div className="flex flex-col items-center justify-center text-center lg:text-start">
          <h1 className="font-roboto text-primary font-bold text-[50px] md:text-[64px]">
            404
          </h1>
          <p className="font-roboto -mt-4 lg:-mt-8 text-primary font-bold text-[40px] md:text-[64px]">
            NOT FOUND
          </p>
          <div className="flex flex-col text-center md:flex-row">
            <p className="font-inter text-[16px] text-gray">
              Couldn't find that.{" "}
            </p>
            <button
              onClick={goBack}
              className="underline text-primary cursor-pointer ml-2"
            >
              Safely Go Back?{" "}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ErrorPage;
